module.exports = "<div class=\"deck row col-xs-offset-2 col-xs-8\" *ngIf=\"sortedDeliverables$ | async as deliverables\">\n  <div *ngFor=\"let deliverable of deliverables; trackBy: trackByFn\">\n      <itpx-multi-content-deliverable [initState]=\"deliverable\" (triggerParent)=\"onTriggerParent($event)\"></itpx-multi-content-deliverable>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/material/multi-content-deliverable-list/multi-content-deliverable-list.component.html
// module id = 951
// module chunks = 0